import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-emerald-200 selection:text-emerald-900" data-id="element-0">
      <Navigation data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <About data-id="element-5" />
        <Contact data-id="element-6" />
      </main>

      <Footer data-id="element-7" />
    </div>;
}